import { Box, CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';

function Loader({ openLoader }) {
  return (
    <Box>
      <Dialog open={openLoader} className="loaderWrap">
        <DialogTitle className="loader-title">Please wait!</DialogTitle>
        <DialogContent className="loader-content">
          <Box className="loaderBar">
            <CircularProgress />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
export default Loader;
